<template>
<!-- :xs="8" :sm="6" :md="4" :lg="3"  -->
    <span id="contact">
        <el-row :gutter="20">
            <el-col :xs="24" ><h1 style="font-size: 35px !important" class="chevere-title">¡Contáctanos!</h1></el-col>
            <el-col :xs="24" >
                <font-awesome-icon icon="user" />
                <input @focus="placeholderName = '' "
                        @blur="placeholderName = '¿Como te llamas?'" class="input-chevere"  :placeholder="this.placeholderName" v-model="name">
            </el-col>
            <el-col :xs="24" >
                <font-awesome-icon icon="phone" />
                <input @focus="placeholderTlf = '' "
                       @blur="placeholderTlf = '¿Tienes un número de teléfono?'" class="input-chevere"  :placeholder="this.placeholderTlf"  v-model="phone">
            </el-col>                
        </el-row>
        <el-row :gutter="20">
            <el-col :xs="24" >
                <font-awesome-icon icon="map" />
                <input @focus="placeholderDir = '' "
                        @blur="placeholderDir = '¿De que parte nos escribes?'" class="input-chevere"  :placeholder="this.placeholderDir" v-model="dir">
            </el-col>
            <el-col :xs="24" >
                <font-awesome-icon icon="envelope" />
                <input @focus="placeholderMail = '' "
                        @blur="placeholderMail = 'Déjanos tu correo para poder responderte'" class="input-chevere"  :placeholder="this.placeholderMail" v-model="email" type="email" >
            </el-col>                
        </el-row>
        <el-row :gutter="20">
            <el-col :xs="24" >
                <font-awesome-icon icon="comment" />
                <input @focus="placeholderHist = '' "
                        @blur="placeholderHist = 'Ahora, ¡cuentanos tu historia!'" class="input-chevere"  :placeholder="this.placeholderHist" v-model="problem">
            </el-col>
            <el-col :xs="24" >
                <br>
                <el-button class="chevere-send" @click="SendMail()" type="primary" icon="el-icon-send">¡Enviar!</el-button>
            </el-col>                
        </el-row>
    </span>
</template>

<script>
import axios from 'axios';

export default {
    name: "Mision",
    data () {
    return {
        /*formulario */
        name: null,
        phone: null,
        dir: null,
        email: null,
        problem: null,
        message:null,
        errors: [],
        /*fin formulario */
        placeholderName : '¿Como te llamas?',
        placeholderTlf : '¿Tienes un número de teléfono?',
        placeholderDir : '¿De que parte nos escribes?',
        placeholderMail : 'Déjanos tu correo para poder responderte',
        placeholderHist : 'Ahora, ¡cuentanos tu historia!'
        }
    }, 
    methods :{
        async SendMail () {  
            this.$message({
                message: 'Su mensaje esta siendo enviado, porvavor sea paciente, gracias.',
                type: 'info'
            });
            if(isNaN(this.phone) && this.phone === null)
            {
                this.message = "Estimado, el número de teléfono debe contener solo números"
                this.failure()
                return
            }
            if( this.name === null)
            {
                this.message = "Porfavor necesitamos que nos diga su nombre para saber como llamarlo"
                this.failure()
                return
            }
            if( this.email === null)
            {
                this.message = "Tiene que dejar su correo para poder comunicarnos con usted"
                this.failure()
                return
            }
            if( this.problem === null)
            {
                this.message = "Si no nos dice que problema tiene, no podremos darle una solución"
                this.failure()
                return
            }
            const params = new URLSearchParams();
            params.append('name', this.name);
            params.append('phone', this.phone);
            params.append('dir', this.dir);
            params.append('email', this.email);
            params.append('problem', this.problem);

            await axios.post('https://mails-api.herokuapp.com/api/SendMail', params);
            this.success ();
        },
        failure () {            
            this.$message.error(this.message);
        },
        success () {
            this.$message({
            message: 'Su mensaje ha sido enviado, nos pondremos en contacto con usted lo más pronto posible.',
            type: 'success'
            });
            this.name= null;
            this.phone= null;
            this.dir= null;
            this.email= null;
            this.problem= null;
        }
    }
    
}
</script>

<style scoped>
.input-chevere{
    background-color: transparent;
    border: none;   
    border-bottom: 1px solid #9e9e9e;
    border-radius: 0;
    outline: none;
    height: 3rem;
    width: 80%;
    font-size: 16px;
    margin: 0 0 8px 0;
    margin-left: 0px;
    padding: 0;
    -webkit-box-shadow: none;
    box-shadow: none;
    -webkit-box-sizing: content-box;
    box-sizing: content-box;
    -webkit-transition: border .3s, -webkit-box-shadow .3s;
    transition: border .3s, -webkit-box-shadow .3s;
    transition: box-shadow .3s, border .3s;
    transition: box-shadow .3s, border .3s, -webkit-box-shadow .3s;
    margin-top: 2%;
    margin-left: 1%;
    padding-right: 2%;
}

.input-chevere:focus {
  border-bottom: 3px solid rgb(211,18,130);  
}

.chevere-send{
    background-color: rgb(13,6,36);
    border: 3px solid rgb(13,6,36);
}

.chevere-send:hover{
    background-color: rgb(59,14,116);
    border: 3px solid rgb(59,14,116);
}
</style>





// WEBPACK FOOTER //
// src/sections/Contactanos.vue